import React from 'react';

import { Icon, IconType } from 'modules/ui';
import { useFelaEnhanced } from 'hooks';

import * as felaRules from './DocumentInfoIcon.styles';

interface DocumentInfoIconProps {
    className?: string;
}

export const DocumentInfoIcon = ({ className, ...rest }: DocumentInfoIconProps) => {
    const { styles } = useFelaEnhanced(felaRules);
    return (
        <span className={styles.iconWrapper}>
            <span className={className}>
                <Icon type={IconType.INFO} className={styles.icon} data-testid="popover-icon" {...rest} />
            </span>
        </span>
    );
};
